import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
const SelectLuvers = (props: any) => {
  return (
    <div>
      {props.konfigured["luvers"] === "mieszany_oczka" ? (
        <FormControl>
          <InputLabel id="demo-simple-select-label">Oczka</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name={props.name}
            value={props.value}
            onChange={(e) => props.onSelectChange(e)}
          >
            {props.luverSelects.map((el: any) => (
              <MenuItem value={el.id}>{el.title}</MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        ""
      )}
    </div>
  );
};

export default SelectLuvers;
